import {DceJsx, DceJsxRenderer} from "dce-jsx";
import {ChainedCommands, Editor} from "@tiptap/core";
import {Transaction, NodeSelection} from "prosemirror-state";
import ICONS from "../assets/ICONS";
import {ToolbarItem} from "./ToolbarItem";

export interface BlockFormatsOptions {
    customBlockClasses?: {
        key: string,
        label: string,
        blockClass: string,
    }[]
}

export class BlockFormatsItem extends ToolbarItem {

    private editor: Editor;

    private dropdownItems: Map<string, HTMLElement> = new Map<string, HTMLElement>();
    private currentName: HTMLElement;

    //token, name, action, state
    private blocks: [string, string, ((editor: Editor) => ChainedCommands), ((editor: Editor) => boolean)][] = [
        ['p', 'Akapit', e => e.chain().setParagraph(), e => e.isActive('paragraph')],
        ['h1', 'Nagłówek 1', e => e.chain().toggleHeading({level: 1}), e => e.isActive('heading', {level: 1})],
        ['h2', 'Nagłówek 2', e => e.chain().toggleHeading({level: 2}), e => e.isActive('heading', {level: 2})],
        ['h3', 'Nagłówek 3', e => e.chain().toggleHeading({level: 3}), e => e.isActive('heading', {level: 3})],
        ['h4', 'Nagłówek 4', e => e.chain().toggleHeading({level: 4}), e => e.isActive('heading', {level: 4})],
        ['h5', 'Nagłówek 5', e => e.chain().toggleHeading({level: 5}), e => e.isActive('heading', {level: 5})],
        ['h6', 'Nagłówek 6', e => e.chain().toggleHeading({level: 6}), e => e.isActive('heading', {level: 6})],

        ['codeblock', 'Kod', e => e.chain().toggleCodeBlock(), e => e.isActive('codeblock')],
        ['blockquote', 'Cytat', e => e.chain().toggleBlockquote(), e => e.isActive('blockquote')],

    ];


    constructor(options: BlockFormatsOptions) {
        super();

        if(options.customBlockClasses){

            for(let cust of options.customBlockClasses){

                this.blocks.push([
                    cust.key,
                    cust.label,
                    e => {
                        return e.chain().toggleBlockClass(cust.blockClass);
                    },
                    e => e.isActive('blockclass', {'blockClass': cust.blockClass})
                ]);

            }

        }
    }

    public mount(editor: Editor): void {
        this.editor = editor;
    }

    bindByRef(ref: string, elem: HTMLElement) {

        if (ref == 'dropdown-item') {
            this.dropdownItems.set(elem.dataset['block'], elem);
        }

        if (ref == 'current-name') {
            this.currentName = elem;
        }

    }

    public consumeTransaction(editor: Editor, transaction: Transaction): void {
        console.log("Image Item transaction");

        let selected = [ this.blocks[0][0] ];

        let current = this.blocks.filter((v) => {
            return v[3](editor);
        });

        if(current.length == 0){
            current = [this.blocks[0]];
        }

        selected = current.map(s => s[0]);

        this.currentName.innerHTML = current.map(a => a[1]).join("/");

        this.dropdownItems.forEach((item, key) => {

            if (selected.indexOf(key) > -1) {
                item.classList.add('selected');
            } else {
                item.classList.remove('selected');
            }
        });


    }

    public click() {
        //open menu

        if (!this.root.classList.contains('disabled')) {
            if (!this.root.classList.contains('opened')) {
                this.root.classList.add('opened');
            } else {
                this.root.classList.remove('opened');
            }
        }

    }

    public clickItem(e: any) {

        let block = e.target.dataset['block'];

        console.log(block);

        let current = this.blocks.filter((v) => {
            return v[0] == block;
        }).shift();

        console.log(current);

        if (current) {
            current[2](this.editor).run();
        }
    }

    render(): JSX.Element {
        return (
            <button type="button" onClick={() => this.click()} className={"btn dropdown"}
                    style={{whiteSpace: "nowrap", textAlign: "left"}}>
                <i ref={"icon"} dangerouslySetInnerHTML={{__html: ICONS.header}}></i>
                <span ref={"current-name"} style={{width: "100px", display: "inline-block"}}>Akapit</span>

                <div className={"options"}>
                    {
                        this.blocks.map(i => {
                            return (
                                <div className={"option " + " block-" + i[0]} data-block={i[0]} ref={"dropdown-item"}
                                     onClick={(e) => this.clickItem(e)}>{i[1]}</div>
                            )
                        })
                    }
                </div>
            </button>
        )
    }

}

